import { Button, GridRow, GridColumn } from "designSystem/index";
import React from "react";

export default () => {
	return (
		<GridColumn
			spacing={10}
			textAlign="left"
		>
			<GridRow 
				alignItems="center"
				growChild={0}
				spacing={2}
				textAlign="left"
			>
				<Button
					design="secondary"
					res="Back"
				/>
				<Button
					design="primary"
					res="Next"
				/>
				<Button
					design="link"
					res="Cancel"
				/>
			</GridRow>
			<GridRow 
				alignItems="center"
				growChild={1}
				spacing={2}
				textAlign="left"
			>
				<Button
					design="secondary"
					res="Back"
				/>
				<Button
					design="primary"
					res="Next"
				/>
				<Button
					design="link"
					res="Cancel"
				/>
			</GridRow>
		</GridColumn>
	);
};